import { Injectable } from '@jack-henry/frontend-utils/di';
import { CompanyAccountsClient } from '@treasury/api/channel';

@Injectable()
export class CompanyAccountService {
    constructor(private readonly companyAccountsClient: CompanyAccountsClient) {}

    public async getCutoffTimes() {
        const dto = await this.companyAccountsClient.companyAccountsGetCutoffTimes({
            maxAgeInSeconds: 600,
        });
        return dto.data;
    }
}
